export const M_SET_APP_STATE = 'M_SET_APP_STATE';
